import { useCookieAuthRefresh } from '@backstage/plugin-auth-react';
import { PropsWithChildren, useEffect } from 'react';

const RETRY_DELAY_MS = 60_000;

// Keeps the proxy plugin's auth cookie fresh: the pod Grafana iframe cannot send a token.
export function ProxyCookieAuth({ children }: PropsWithChildren) {
  const state = useCookieAuthRefresh({ pluginId: 'proxy' });
  const retry = state.status === 'error' ? state.retry : undefined;

  useEffect(() => {
    if (!retry) {
      return undefined;
    }
    const timeout = setTimeout(retry, RETRY_DELAY_MS);
    return () => clearTimeout(timeout);
  }, [retry]);

  return <>{children}</>;
}
